import api from '@/lib/api'
import { ENDPOINTS } from '@/constants/endpoints'

export interface ScientificCorporaItem {
  id: string
  content: string
  image: string
  created_at: string
  updated_at: string
}

export interface ScientificCorporaSection {
  id: string
  title: string
  header: string
  items: ScientificCorporaItem[]
  created_at: string
  updated_at: string
}

export interface ScientificCorporaResponse {
  count: number
  next: string | null
  previous: string | null
  results: ScientificCorporaSection[]
}

export interface GetScientificCorporaParams {
  limit?: number
  offset?: number
}

export interface TeamCategory {
  id: string
  name: string
  created_at: string
  updated_at: string
}

export interface TeamMember {
  id: string
  name: string
  role: string
  image: string
  category: TeamCategory
  created_at: string
  updated_at: string
}

export interface TeamCategoryResponse {
  count: number
  next: string | null
  previous: string | null
  results: TeamCategory[]
}

export interface TeamMemberResponse {
  count: number
  next: string | null
  previous: string | null
  results: TeamMember[]
}

export interface CmsListParams {
  limit?: number
  offset?: number
}

export interface FaqItem {
  id: string
  question: string
  answer: string
  order: number
  created_at: string
  updated_at: string
}

export interface FaqListResponse {
  count: number
  next: string | null
  previous: string | null
  results: FaqItem[]
}

export interface GetFaqParams {
  limit?: number
  offset?: number
}

export const cmsService = {
  getScientificCorpora: async (
    params?: GetScientificCorporaParams
  ): Promise<ScientificCorporaResponse> => {
    const response = await api.get<ScientificCorporaResponse>(ENDPOINTS.CMS.SCIENTIFIC_CORPORA, {
      params,
    })
    return response.data
  },

  getTeamCategories: async (params?: CmsListParams): Promise<TeamCategoryResponse> => {
    const response = await api.get<TeamCategoryResponse>(ENDPOINTS.CMS.TEAM_CATEGORIES, {
      params,
    })
    return response.data
  },

  getTeamMembers: async (params?: CmsListParams): Promise<TeamMemberResponse> => {
    const response = await api.get<TeamMemberResponse>(ENDPOINTS.CMS.TEAM_MEMBERS, {
      params,
    })
    return response.data
  },

  getFaq: async (params?: GetFaqParams): Promise<FaqListResponse> => {
    const response = await api.get<FaqListResponse>(ENDPOINTS.CMS.FAQ, { params })
    return response.data
  },
}
